import React from 'react'
import { useAuth } from 'react-oidc-context'
import { useNavigate } from 'react-router-dom'

const Logout = () => {
  const navigate = useNavigate()
  const auth = useAuth()

  try {
    auth.signoutRedirect()
  } catch (e) {
    console.error('Error during logout:', e)
    navigate('/')
  }
  return <></>
}

export default Logout
